export default {
    title: `<i class="fa fa-lg fa-pencil-square"></i> 텍스트와 제목 설정하기`,
    datas: [
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 일반 텍스트`
        },
        { type: "text",
            content: "일반적인 텍스트를 작성할 때는 특별한 문법은 없습니다. 그냥 텍스트 내용을 입력하면 됩니다. "
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section01/exam01.md",
            content:
`Hello Markdown World~!

그냥 텍스트를 입력합니다.`
        },        
        { type: "text",
            content: "다만 알아둬야할 주의점이 있는데 아래와 같습니다."
        },
        { type: "text",
            content: 
`<ul>
    <li>텍스트 입력 중간 등의 상황에서 줄넘김을 하려면 문장 마지막에 2개 이상의 공백(Space)가 있어야합니다.</li>
    <li>여러번의 공백(Space)을 반복 입력해도 한글자 공백(Space)이 됩니다.</li>
    <li>마찬가지로 줄넘김 또한 여러번 줄을 넘겨도 한줄만 넘어갑니다.</li>
</ul>`
        },
        { type: "text",
            content: "HTML 문서를 작성해본 경험이 있다면 동일한 현상을 격어보았을 것입니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section01/exam02.md",
            content:
`줄넘김은 마지막에
두개 이상의 공백이 없으면 
한줄로 표시됩니다.

여러       칸을     띄워도 한   칸   공백으로  처리     됩니다.




마찬가지로 여러 줄을 넘겨도





한줄만 넘겨집니다.`
        },
        { type: "text",
            content: "위와 같이 공백과 줄넘김을 마구 사용한 마크다운 문서를 작성하고 확인해 봅시다."
        },



        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 글씨 굵게하기, 기울리기`
        },
        { type: "text",
            content: "글 중간에 특정 문자나 문장을 강조하거나 포인트를 주고 싶을 때 자주 사용되는 방법들입니다. "
                + "글씨를 강조할때는 *(별포)기호나 _(언더바)기호를 사용하면 됩니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section01/exam03.md",
            content:
`글씨를 강조하기 위해서 **글씨를 굵게**하거나 *기울림꼴*을 자주 사용합니다.

__*굵은 글씨가 기울기까지*__ 함께 적용하려면 다른 기호를 적절히 섞어 사용합니다.`
        },
        { type: "text",
            content: "위처럼 강조할 문자 앞뒤를 기호 한개(기울림) 또는 두개(굵게)로 묶어주면 되는데, "
            + "이때 강조하는 문자의 앞뒤에 공백이 들어가면 안된다는 점에 유의해야 합니다. "
            + "<small>(그리고 _기호가 *기호에 비해 까다로운 경향이 있어 *기호를 우선적으로 사용하는 것을 권장합니다.)<small>"
        },
        { type: "text",
            content: "글 중간에 특정 문자나 문장을 강조하거나 포인트를 주고 싶을 때 자주 사용되는 방법들입니다. "
                + "글씨를 강조할때는 *(별포)기호나 _(언더바)기호를 사용하면 됩니다."
        },



        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 글자에 취소선 그리기`
        },
        { type: "text",
            content: "글자 꾸미기의 마지막으로 글자에 취소선을 긋는 방법을 알아봅니다. ~(물결)기호를 사용합니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section01/exam04.md",
            content: `글씨에 ~~취소선~~을 만들수 있습니다.`
        },
        { type: "text",
            content: "글씨를 굵게 하는 방법과 유사하게 물결두겹을 강조하고 싶은 글자 앞뒤에 붙여줍니다."
        },



        { type: "subtitle",
            content: `<i class="fa fa-check-square"></i> Check it!`
        },
        { type: "oxquiz",
            content: "마크다운에서는 글자를 강조할때 굵기와 기울림꼴을 함께 사용할 수 없다.",
            ans: false,
        },
        { type: "oxquiz",
            content: "마크다운에서는 여러칸 띄어쓰기와 여러줄 넘기기를 사용할 수 없다.",
            ans: true,
        },
        // { type: "oxquiz",
        //     content: "마크다운에서 글자를 색상을 변경할 수 없다.",
        //     ans: true,
        //     hint: "Github에서 링크 이외의 글자에 색이 있는 것을 본적이 있나요?"
        // },


        { type: "subtitle",
            content: `<i class="fa fa-exclamation-triangle"></i> 할 수 없는 일들에 관해...`
        },
        { type: "text",
            content: "종종 문의를 받는데 지원하고 있지 않는 문법이 있습니다." +
`<ul>
    <li>글씨에 색상 설정은 불가능 합니다.</li>
    <li>문단 정렬은 불가능합니다.</li>
</ul>`
                + "위와 같은 작업들은 Github에서 의도적으로 사용하지 않도록 막아둔 사항입니다. 사용할 방법이 있더라도 가급적 자제하도록 합시다."
        },
        


        { type: "next",
            content: "다음",
            url: "/sections/02"
        },
    ]
}